export const ACCOUNT_TYPE = {
    JOBSEEKER: "JobSeeker",
    CREATOR: "Creator",
}
 